import type { FaireProductEntity } from "../../entity_types/product";

export const p_jdyv6hmyen: FaireProductEntity = {
  token: "p_jdyv6hmyen",
  type: "product",
  name: "Handblown Short Stemmed Wine Glass",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/b490ba7db7c0b5f9978d40702090a17794aa5173607683bedf768e92f55ec42b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/199e0528a27c0eb7dda1dcdf6f93e35f5cb3e54fa07b38c55cf82af62bbdeeaf.jpeg",
    "https://cdn.faire.com/fastly/342aa688ab25aa2b75655d22a6cb3e7983d874c1690d0587c0443ae53c254d88.jpeg",
    "https://cdn.faire.com/fastly/860668b8b29dec27519f6d4f5296b09fe075cee39a2bf302025b2ec86f539580.jpeg",
    "https://cdn.faire.com/fastly/d813b55779bc6d81566bf912cd9c4c1f3433c77cf0ef673f92c3030f5be1de4b.jpeg",
    "https://cdn.faire.com/fastly/0b8dbbb43a54b2e76c83bdbf454c7eafbb69596ec422c5591427c8c46203fa6f.jpeg",
  ],
  priceDollars: 15,
  description:
    "**Packaged in sets of 2 as shown; sold as 8 single glasses in a master (4 boxes of 2 glasses). Price shown is per glass.**\n\nArtisan-made in Mexico, these handblown short-stemmed wine glasses feature a refined, hand-etched design that adds character to every pour. Sturdy yet elegant, they’re perfect for casual dinners or celebratory toasts—each one uniquely crafted by hand.\n\nCare: Dishwasher safe - Susceptible to breakage with extreme temperature changes. \n\nDimensions: 4'' height x 2.6'' diameter; 7.5 oz capacity (due to the handblown nature, variances may occur).",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:54:56.814Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
